<template>
  <div id="app">
    <router-view/>
    <!--    <keep-alive include="Home">-->
    <!--      <router-view></router-view>-->
    <!--    </keep-alive>-->
  </div>
</template>

<script>
export default {
  name: "App",
  created() {

    this.$store.dispatch('setPageCurrentIndex', 0)
    this.getHomeData()
  },
  methods: {
    async getHomeData() {
      let {data} = await this.$api.getData('home')
      await this.$store.dispatch('setStoreByKeyData', {key: 'setHomeData', data: data})
    }
  },
  mounted() {
    let screenWidth = document.body.clientWidth;
    if (screenWidth < 960) {
      this.$store.dispatch('setIsMobile', 2)
    } else {
      this.$store.dispatch('setIsMobile', 1)
    }
    const t = this;
    window.onresize = () => {
      return (() => {
        let screenWidth = document.body.clientWidth;
        if (screenWidth < 960) {
          t.$store.dispatch('setIsMobile', 2)
        } else {
          t.$store.dispatch('setIsMobile', 1)
        }
      })();
    };
  }
};
</script>
<style>

@font-face {
  font-family: "AvenirLTStdBlack";
  src: url("./assets/font/AvenirLTStd-Black.otf") format('openType');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OPPOSansB";
  src: url("./assets/font/OPPOSans-B.ttf") format('openType');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OPPOSansH";
  src: url("./assets/font/OPPOSans-H.ttf") format('openType');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OPPOSansL";
  src: url("./assets/font/OPPOSans-L.ttf") format('openType');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OPPOSansM";
  src: url("./assets/font/OPPOSans-M.ttf") format('openType');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "OPPOSansR";
  src: url("./assets/font/OPPOSans-R.ttf") format('openType');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "AvenirLTStdMedium";
  src: url("./assets/font/AvenirLTStd-Medium.otf") format('openType');
  font-weight: normal;
  font-style: normal;
}

.fAm {
  font-family: AvenirLTStdMedium, sans-serif !important;
}

.fAb {
  font-family: AvenirLTStdBlack, sans-serif !important;
}

.fOb {
  font-family: OPPOSansB, sans-serif !important;
}

.fOH {
  font-family: OPPOSansH, sans-serif !important;
}

.fOL {
  font-family: OPPOSansL, sans-serif !important;
}

.fOM {
  font-family: OPPOSansM, sans-serif !important;
}

.fOR {
  font-family: OPPOSansR, sans-serif !important;
}

.zwHeader {
  height: 4rem !important;
}

* {
  padding: 0;
  margin: 0;
}

ul {
  padding-left: 40px !important;
}

.qzOpNo {
  opacity: 0 !important;
}

#app {

}

@media (min-width: 960px) {
  /* 自定义整个滚动条 */
  *::-webkit-scrollbar {
    width: 5px; /* 对于垂直滚动条，设置宽度 */
  }

  /* 自定义滚动条轨道 */
  *::-webkit-scrollbar-track {
    background: #fff; /* 轨道颜色 */
  }

  /* 自定义滚动条的滑块（thumb） */
  *::-webkit-scrollbar-thumb {
    background: #909399; /* 滑块颜色 */
  }
}

/* 当屏幕宽度大于或等于768像素时，改为浮动布局 */
@media (min-width: 1400px) {
  html {
    font-size: 16px;
  }
}

@media (min-width: 960px) and (max-width: 1400px) {
  html {
    font-size: 14.5px;
  }
}

@media (max-width: 960px) {
  html {
    font-size: 16px;
  }

  * {
    scrollbar-width: none; /* Chrome, Safari, Opera */
    -ms-overflow-style: none; /* IE and Edge */
  }

  *::-webkit-scrollbar {
    display: none; /* Firefox */
  }
}

img {
  display: block;
  -webkit-user-drag: none; /* 针对Chrome、Safari等Webkit内核浏览器 */
  -khtml-user-drag: none; /* 针对早期的Konqueror浏览器 */
  -moz-user-drag: none; /* 针对Firefox浏览器 */
  -ms-user-drag: none; /* 针对IE/Edge浏览器 */
  user-drag: none;
}

.flexB {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flex1 {
  flex: 1;
}

.h100 {
  height: 100%;
}

.w100 {
  width: 100%;
}

.fb {
  //font-weight: bold;
}

.pw100 {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  height: 100%;
  z-index: 1;
  width: 100%;
}

.h100 {
  height: 100%;
}

.flexSw {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.newsPImage {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  overflow: hidden;
  overflow-x: auto;
  img{
    width: 70vw !important;
    @media (max-width: 960px) {
      width: 93vw !important;
    }
  }
}
</style>
